import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { IPositionsdaten } from '../_interfaces/positionsdaten';
//import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class PositionsdatenService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'reihenfolge', type: 'int'},
    {name: 'bezeichnung', type: 'string'},
    {name: 'bemerkung', type: 'string'},
    {name: 'bemerkungBehoben', type: 'string'},
    {name: 'platzhalter', type: 'string'},
    {name: 'bewertungIO', type: 'bool'},
    {name: 'bewertungNiO', type: 'bool'},
    {name: 'bewertungBehoben', type: 'bool'}
  ];
    
  getPositionsdatenCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ positionsdaten: IPositionsdaten[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'positionsdaten?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          return { positionsdaten: <IPositionsdaten[]>response.body, pagination: <IPagination>JSON.parse(response.headers.get('x-pagination')) };
        }), catchError(this.handleError))
  }

  getPositionsdaten(id: number): Observable<IPositionsdaten> {

    if (id === 0) {
      // return Observable.create((observer: any) => {
      //   observer.next(this.initializePositionsdaten());
      //   observer.complete();
      // })
      return of(this.initializePositionsdaten());
    }

    return this.httpClient.get<IPositionsdaten>(this.apiBaseUrl + 'positionsdaten/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError));
  }

  savePositionsdaten(positionsdaten: IPositionsdaten): Observable<IPositionsdaten> {
    // DateTimeOffset-Fix
    let itemToSave = cloneDeep(positionsdaten); // clonen, um sicherzustellen, dass das Original-Objekt nicht ver�ndert wird, evtl. passiert nach dem Save noch etwas damit ?
    //console.log("PositionsdatenService.saveSingularCapitalized#() itemToSave before DateTimeOffset-Fix:", itemToSave);
    this.propertyTypes.filter(f => f.type.toLowerCase() == 'datetimeoffset').forEach(propertyType => {
      if (itemToSave[propertyType.name] != null) {
        itemToSave[propertyType.name] = moment(itemToSave[propertyType.name]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // alle datetimeoffset-felder entspr. formatieren, dass in der API auch der Offset ankommt!
      }
    });
    //console.log("PositionsdatenService.saveSingularCapitalized#() itemToSave after DateTimeOffset-Fix:", itemToSave);

    if (positionsdaten.id === 0) {
      return this.createPositionsdaten(/*positionsdaten*/itemToSave);
    }

    return this.updatePositionsdaten(/*positionsdaten*/itemToSave)

  }

  updatePositionsdaten(positionsdaten: IPositionsdaten): Observable<IPositionsdaten> {

    return this.httpClient.put<IPositionsdaten>(this.apiBaseUrl + 'positionsdaten/' + positionsdaten.id, positionsdaten, { headers: httpOptions, observe: 'body', withCredentials: true })
    .pipe(catchError(this.handleError))

  }

  deletePositionsdaten(id: number) {

    return this.httpClient.delete(this.apiBaseUrl + 'positionsdaten/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(
        catchError(this.handleError)
      )
  }

  createPositionsdaten(positionsdaten: IPositionsdaten): Observable<IPositionsdaten> {
    return this.httpClient.post<IPositionsdaten>(this.apiBaseUrl + 'positionsdaten', positionsdaten, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError))
  }

  initializePositionsdaten(): IPositionsdaten {
    return {
      id: 0,
      createdBy: '',
      created: /*''*/'0001-01-01T00:00:00.000Z', // fix
      modifiedBy: '',
      modified: /*''*/'0001-01-01T00:00:00.000Z', // fix
      rowVersion: '',
      reihenfolge: 0,
      bezeichnung: '',
      bemerkung: '',
      bemerkungBehoben: '',
      platzhalter: '',
      bewertungIO: false,
      bewertungNiO: false,
      bewertungBehoben: false,

      checklistePositionId: null,
      checklistePosition: null,
      kopfdatenId: null,
      kopfdaten: null,
      positionsdatenFelder: [],
      positionsdatenFotos: [],
    };
  }


}
